import { ApiUserLocation } from 'api/types/ApiUserLocation';
import { ApiUserEnvironmentUserLocation } from 'api/userEnvironment/types/ApiUserEnvironment';
import { SearchLocation } from 'modules/search/types/SearchLocation';

export const searchLocationToUserLocation = (
  location: SearchLocation | null | undefined,
): ApiUserLocation | null => {
  if (!location) {
    return null;
  }

  const {
    text: locationText,
    stateCode,
    countryCode,
    latitude,
    longitude,
  } = location;
  return {
    locationText,
    stateCode,
    countryCode,
    latitude,
    longitude,
  };
};

export const userLocationToSearchLocation = (
  location: ApiUserLocation | null | undefined,
): SearchLocation | null => {
  if (!location) {
    return null;
  }

  const {
    locationText: text,
    stateCode,
    countryCode,
    latitude,
    longitude,
  } = location;
  return {
    text,
    stateCode,
    countryCode,
    latitude,
    longitude,
  };
};

export const searchLocationToUserEnvironmentUserLocation = (
  location: SearchLocation | null | undefined,
): ApiUserEnvironmentUserLocation | null => {
  if (!location) {
    return null;
  }

  const { text, stateCode, countryCode, latitude, longitude } = location;
  if (text && stateCode && countryCode && latitude && longitude) {
    return {
      text,
      stateCode,
      countryCode,
      latitude: latitude.toString(),
      longitude: longitude.toString(),
    };
  }
  return null;
};
